export const apiGeoLocation = (options) => {
  this.geolocate({
    success: function (pos) {
      if (typeof options.callback === 'function') {
        options.callback(pos)
      }
    },
  })
}
